import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { loginUser } from "../../../_actions/user_actions";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Form, Input, Button, Checkbox, Typography, Spin } from 'antd';
import { useDispatch } from "react-redux";
import { authService } from "./FirebaseServiceAccount";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import styled from "styled-components";

const { Title } = Typography;

export const BtnFullWidth = styled(Button)`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MyForm = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

function LoginPage(props) {
  const dispatch = useDispatch();

  const [formErrorMessage, setFormErrorMessage] = useState('')
  const [rememberMe, setRememberMe] = useState(localStorage.getItem("rememberMe") ? localStorage.getItem("rememberMe") : true)
  const [isLoading, setIsLoading] = useState(false);

  const handleRememberMe = () => {
    setRememberMe(!rememberMe)
  };

  const initialEmail = rememberMe && localStorage.getItem("email") ? localStorage.getItem("email") : '';

  function requestLogin(email, password, name, loginType = process.env.REACT_APP_LOGIN_TYPE_DEFAULT) {

    let dataToSubmit = {
      email,
      password,
      fcmregtk: localStorage.getItem('fcmregtk'),
      loginType,
    };

    dispatch(loginUser(dataToSubmit))
      .then(response => {
        if (response.payload.loginSuccess) {
          if (rememberMe) {
            localStorage.setItem('email', email);
          } else {
            localStorage.removeItem('email');
          }
          props.history.push("/");
        } else if (response.payload.errCode == 2) {
          alert(response.payload.message + ":" + email);
        } else {
          console.log('회원가입으로 이동');
          props.history.push({
            pathname: "/register",
            state: { email, password, name }
          });
        }
      });
  }

  const onClickGoogleLogin = e => {
    console.log('onClickGoogleLogin');

    if (window?.Android) {
      console.log('request Android SignIn');
      window.Android.getSignIn('requestSignIn');
    }
    else {
      const email_droid = localStorage.getItem('email_droid');
      const uid_droid = localStorage.getItem('uid_droid');
      const name_droid = localStorage.getItem('name_droid');
      if (email_droid && uid_droid && name_droid) {
        requestLogin(email_droid, email_droid, name_droid, 'Android');
      }
      else {
        setIsLoading(true);
        signInWithPopup(authService, new GoogleAuthProvider())
          .then(successGoogleSignIn)
          .catch((error) => {
            console.log('Google Sign-In Error:', error);
            alert('Google 로그인 중 오류가 발생했습니다: ' + error.message);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    }
  };

  const successGoogleSignIn = (result) => {

    // This gives you a Google Access Token. You can use it to access the Google API.
    const credential = GoogleAuthProvider.credentialFromResult(result);
    // const token = credential.accessToken;//이건 user 고유의 번호가 아님. 안드로이드/웹 접속시 각각 달라짐.
    // The signed-in user info.
    const user = result.user;

    // As this API can be used for sign-in, linking and reauthentication,
    // check the operationType to determine what triggered this redirect
    // operation.
    const operationType = result.operationType;
    console.log('operationType:', operationType); //signIn
    console.log('result?.providerId:', result?.providerId); //google.com
    // console.log('user?.uid:', user?.uid); //Unique ID

    requestLogin(user.email, user.email, user.displayName, result?.providerId);
  };


  useEffect(() => {

    window.signInCallback = (email, password, name, loginType = 'UnknownDevice') => {
      console.log('signInCallback()');
      requestLogin(email, email, name, loginType);
    };

  }, []);


  return (
    <Formik
      initialValues={{
        email: initialEmail,
        password: '',
      }}

      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email('이메일 형식이 올바른지 확인해주세요')
          .required('이메일을 입력해주세요'),
        password: Yup.string()
          .min(6, '비밀번호는 6자 이상이어야 합니다')
          .required('비밀번호를 입력해주세요'),
      })}

      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          let dataToSubmit = {
            email: values.email,
            password: values.password,
            fcmregtk: localStorage.getItem('fcmregtk')
          };

          dispatch(loginUser(dataToSubmit))
            .then(response => {
              if (response.payload.loginSuccess) {
                if (rememberMe) {
                  window.localStorage.setItem('email', values.email);
                } else {
                  localStorage.removeItem('email');
                }
                props.history.push("/");
              } else {
                setFormErrorMessage('일치하는 이메일/비밀번호 정보가 없습니다. 회원가입후 사용해주세요')
              }
            })
            .catch(err => {
              setFormErrorMessage('일치하는 이메일/비밀번호 정보가 없습니다. 회원가입후 사용해주세요')
              setTimeout(() => {
                setFormErrorMessage("")
              }, 3000);
            });
          setSubmitting(false);
        }, 500);
      }}
    >
      {props2 => {
        const {
          values,
          touched,
          errors,
          dirty,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,
        } = props2;
        return (
          <div className='page'>

            <Title level={2}>로그인</Title>
            <MyForm onSubmit={handleSubmit}>

              <br />
              <Spin spinning={isLoading} tip="로그인 정보 확인 중">
                <BtnFullWidth style={{ width: '100%' }} icon={<img style={{ width: '20px', marginRight: '10px' }} src="/images/Google-Logo-icon.png" />} onClick={onClickGoogleLogin}>
                  Google 간편 로그인
                </BtnFullWidth>
              </Spin>

              <br />
              Or
              <br />
              <br />

              <Form.Item required>
                <Input
                  id="email"
                  prefix={<img src="/images/user.png" alt="user" />}
                  placeholder="이메일을 입력하세요"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.email && touched.email ? 'text-input error' : 'text-input'
                  }
                />
                {errors.email && touched.email && (
                  <div className="input-feedback">{errors.email}</div>
                )}
              </Form.Item>

              <Form.Item required>
                <Input
                  id="password"
                  prefix={<img src="/images/lock.png" alt="lock" />}
                  placeholder="비밀번호를 입력하세요"
                  type="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.password && touched.password ? 'text-input error' : 'text-input'
                  }
                />
                {errors.password && touched.password && (
                  <div className="input-feedback">{errors.password}</div>
                )}
              </Form.Item>

              {formErrorMessage && (
                <label ><p style={{ color: '#ff0000bf', fontSize: '0.7rem', border: '1px solid', padding: '1rem', borderRadius: '10px' }}>{formErrorMessage}</p></label>
              )}

              <Checkbox id="rememberMe" onChange={handleRememberMe} checked={rememberMe} >회원정보 기억하기</Checkbox>
              {/* <a className="login-form-forgot" href="/reset_user" style={{ float: 'right' }}>
                forgot password
              </a> */}
              <Button style={{ width: '100%' }} type="primary" htmlType="submit" className="login-form-button" disabled={isSubmitting} onSubmit={handleSubmit}>
                로그인
              </Button>
              Or <a href="/register">회원가입</a>
              Or <a onClick={evt => {
                const emailInput = document.getElementById('email').value;
                props.history.push({
                  pathname: "/forgot_password",
                  state: { email: emailInput }
                });
              }}>비밀번호찾기</a>
            </MyForm>
          </div>
        );
      }}
    </Formik>
  );
};

export default withRouter(LoginPage);


